import { cyrb53 } from "./cyrb53";
import { xorshift } from "./xorshift";

export const randomColorFromSeed = (seed: string) => {
  const rng = xorshift(cyrb53(seed));
  const color = ((rng() * 0xffffff) | 0).toString(16);
  const randomColor = "#" + ("000000" + color).slice(-6);
  return randomColor;
};
